/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { differenceInSeconds } from 'date-fns';
import { ModalTypical, Modal, Button } from 'app/components';
import useConfig from 'app/hooks/useConfig';
// import useUtils from 'app/hooks/useUtils';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,

  sessionRoute: PropTypes.string.isRequired,

  sessionOrder: PropTypes.shape({
    userSessionId: PropTypes.string.isRequired,
    session: PropTypes.object
  }).isRequired,

  sessionPayment: PropTypes.shape({
    start: PropTypes.string.isRequired,
    orderPaymentTTL: PropTypes.number.isRequired
  }).isRequired,

  notify: PropTypes.func.isRequired,
  createOrder: PropTypes.func.isRequired
};

const BookingFailure = ({
  history: { push },
  // sessionOrder,
  sessionRoute
  // sessionPayment,
  // notify,
  // createOrder
}) => {
  const [t] = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const {
    routes,
    supportInfo
  } = useConfig();
  let email = supportInfo?.contactUs?.email;

  useEffect(() => {
    setIsVisible(true);
  }, [])

  return (
    <Modal
      isSmall
      isOpen={isVisible}
      title={t('purchase.modals.payment_contact.header')}
    >

      <ModalTypical
        withIcon={false}
        message={
          <span>
            <span>
              {t('purchase.modals.payment_contact.message')}
              <a href={`mailto:${email}`}>
                <span>{t('purchase.modals.payment_contact.message_email', { email })}</span>
              </a>
              <span>{t('purchase.modals.payment_contact.message_info')}</span>
            </span>
          </span>
        }
      >
        <Button href={routes.movies.pattern} isPrimary style={{ width: '200px' }}>
          {t('common.ok')}
        </Button>
      </ModalTypical>
    </Modal >
  );
};

BookingFailure.propTypes = propTypes;
export default BookingFailure;
